
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public_offer",
      function () {
        return require("private-next-pages/public_offer.tsx");
      }
    ]);
  